import { css } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Colors, Typography } from '../../../theme';
export const Styles = labelStyles('TagLabel', {
    root: css `
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 30px;
    ${Typography.smallPrint1Bold};

    &[data-size='small'] {
      height: auto;
      padding: 0 8px;
    }

    &[data-size='medium'] {
      height: auto;
      padding: 3px 8px;
    }

    &[data-color='gray'] {
      background-color: ${Colors.neutral700};
      color: ${Colors.neutral100};
    }

    &[data-color='white'] {
      background-color: ${Colors.neutral100};
      color: ${Colors.neutral800};
    }

    &[data-color='info'] {
      background-color: ${Colors.blue10};
      color: ${Colors.neutral800};
    }

    &[data-color='success'] {
      background-color: ${Colors.success100};
      color: ${Colors.neutral800};
    }

    &[data-color='warning'] {
      background-color: ${Colors.warning100};
      color: ${Colors.neutral800};
    }

    &[data-color='error'] {
      background-color: ${Colors.error100};
      color: ${Colors.neutral800};
    }

    &[data-color='peach'] {
      background-color: ${Colors.peach};
      color: ${Colors.neutral800};
    }

    &[data-color='neutral300'] {
      background-color: ${Colors.neutral300};
      color: ${Colors.neutral800};
    }

    &[data-color='bolt'] {
      background-color: ${Colors.bolt};
      color: ${Colors.neutral800};
    }

    &[data-color='cream'] {
      background-color: ${Colors.cream};
      color: ${Colors.neutral800};
    }

    &[data-color='success500'] {
      background-color: ${Colors.success500};
      color: ${Colors.neutral100};
    }
  `,
});
//# sourceMappingURL=Styles.js.map
// @zapier/design-system@6.1.0 (fd86aa2ab)
